import PlanejamentoAcaoFormContaCorrenteWrapper from '../../../produto/spa/planejamento-acao/form/PlanejamentoAcaoFormContaCorrenteWrapper';

export default PlanejamentoAcaoFormContaCorrenteWrapper;
